import $ from 'gridstrap/lib/gs-zepto';
import analytics, { invalidReason, stepVariant, type StepRef } from 'gridstrap/lib/gs-analytics';
import { isIE11 } from 'gridstrap/lib/gs-utils';
//declare var ga;

export class GSWizardStep {

	//
	// Properties
	//

	root;
	form;
	wizard;
	panels;
	prevStep;
	nextStep;

	get index()  { return this.root.index(); }
	get height() { return this.root.height(); }

	get gaCategory() { return this.root.data('gsWizardStepGaCategory'); }
	get gaLabel()    { return this.root.data('gsWizardStepGaLabel'); }
	// Funnel telemetry (SC-620): an absent attribute means track everything;
	// a declared list still narrows. No step template declares one today.
	get gaActions()  {
		const actions = this.root.data('gsWizardStepGaActions');
		return actions ? String(actions).split(' ') : null;
	}

	// The authored `data-gs-wizard-step-id`, when the template carries one.
	get name(): string | null {
		const id = this.root.data('gsWizardStepId');
		return id == null || id === '' ? null : String(id);
	}

	// `this.wizard` is still undefined during the first activate(): the wizard
	// initialises before its steps, so nothing here may read it.
	get ref(): StepRef {
		return { stepNumber: this.index + 1, stepName: this.name, stepVariant: stepVariant(this.root.get(0)) };
	}

	get isActive() { return this.root.hasClass('is-active'); }
	get isEngaged() { return this.root.hasClass('is-engaged'); }
	get formFields() { return this.root.find('.gs-FormField'); }
	get invalidFields() { return this.formFields.gs().find(field => field.isValid === false); }

	set offset(value)            { this.root.css('margin-top', value); }
	set isActive(value)          { this.root.toggleClass('is-active', !!value); }
	set isEngaged(value)         { this.root.toggleClass('is-engaged', !!value); }
	set isTopElement(value)      { this.root.toggleClass('is-top-element', !!value); }
	set isTransitioningTo(value) { this.root.toggleClass('is-to-step', !!value); }

	//
	// Methods
	//

	// The legacy action names map onto the funnel vocabulary (ADR-0004). An
	// inline form's events wait in gs-analytics until it scrolls into view.
	track(eventAction) {
		if (this.gaActions && !this.gaActions.includes(eventAction)) return;
		const root = this.root.get(0);
		const invalid = this.invalidFields;
		if (eventAction == 'view') analytics.stepView(root, this.ref);
		if (eventAction == 'engage') analytics.engaged(root, this.index + 1);
		if (eventAction == 'invalid') analytics.invalid(root, this.index + 1, invalidReason(invalid && invalid.root.get(0)));
	}

	activate() {
		this.isActive = true;
		this.track('view');
	}

	engage() {
		if (this.isEngaged) return;
		this.isEngaged = true;
		this.track('engage');
	}

	select() {
		const from = this.wizard.activeStep;
		const isBefore = this.index < from.index;
		const topStep = isBefore ? this : from;
		topStep.isTopElement = true;

		const offsetStart = isBefore ? topStep.height * -1 : 0;
		const offsetEnd = isBefore ? 0 : topStep.height * -1;
		topStep.offset = offsetStart;

		this.isTransitioningTo = true;
		this.wizard.height = from.height;
		this.panels.each((index, panel) => panel.scrollTop = 0);

		setTimeout(() => {

			this.wizard.height = this.height;
			topStep.offset = offsetEnd;
			$(window).trigger('resize');

			this.wizard.root.one('transitionend', () => {
				topStep.isTopElement = false;
				from.isActive = false;
				this.isTransitioningTo = false;
				this.wizard.isAnimating = false;
				this.wizard.activeStep = this;
				this.wizard.height = 'auto';
				this.activate();
				this.autofocus();
			});

		}, 10);
	}

	autofocus() {
		if (isIE11()) return;
		this.root.find('.gs-FormField--autofocus .gs-FormField-input').focus();
	}

	validate() {
		this.formFields.gs('validate');
		let invalid = this.invalidFields;
		if (invalid) invalid.focus();
		return !invalid;
	}

	//
	// Initializers & Event Handlers
	//

	constructor(root) {
		this.root = $(root);
		this.panels = this.root.find('.gs-Wizard-panel');
		this.form = this.root.closest('.gs-Form').gs(0) || {};
		this.root.on('click input change', 'input, textarea, select, button', () => this.engage());
	}

	gsOnInit() {
		this.prevStep = this.root.prev().gs(0);
		this.nextStep = this.root.next().gs(0);
		this.wizard = this.root.closest('.gs-Wizard').gs(0);
	}
}
